import { defineStore } from 'pinia'

export default defineStore("config", {
  state: ()=>({
    slots: {},
    forms: {},
    config: {},
    user: {},
    cart: {},
  }),
  getters: {
  },
  actions: {
    setUser(user) {
      this.user=user;
    },
    setCart(cart) {
      this.cart=cart;
    },
  },
});
